import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { KeycloakAuthService } from '../services/keycloak-auth.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class KeycloakAuthGuard implements CanActivate {
  private keycloakAuth = inject(KeycloakAuthService);
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.keycloakAuth.isAuthenticated()) {
      const returnUrl = this.router.url;
      this.keycloakAuth.redirectToKeycloakLogin(returnUrl);
      return false;
    }

    // Validate session server-side via ping
    return this.userService.pingV2().pipe(
      map(() => true),
      catchError(() => {
        // 401/403 errors are handled by keycloakAuthInterceptor (triggers logout)
        return of(false);
      })
    );
  }
}
